import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { formatPrice } from '../../../utils';

class BoxPaymentMethod extends Component {
  render() {
    const paymentMethod = this.props.payment_methods.filter((payment) => payment.selected)[0] || {
      slug: '',
      name: '',
    };

    const brandSelected = this.props.brands.map((brand) => {
      if (brand.selected) {
        return brand.brand_name;
      }

      return false;
    });

    const parcelSelected = this.props.parcels.map((parcel, i) => {
      if (parcel.selected) {
        return (
          <span key={i}>
            {parcel.times}x de R$ {formatPrice(parcel.price)}
          </span>
        );
      }

      return <span key={i} />;
    });

    const imgBrand = this.props.brands.map((brand, i) => {
      if (brand.selected) {
        return <img key={i} src={`/assets/images/home/home/cards/${brand.brand_name}.svg`} alt="" />;
      }
      return <span key={i} />;
    });

    const selectedBank = this.props.banks.filter((bank) => bank.selected)[0];

    return (
      <div className="box box-payment">
        <div className="payment-method">
          {paymentMethod.slug === 'credit-card' ? (
            <React.Fragment>
              <div>{imgBrand}</div>
              <div>
                <strong className="name-brand">{brandSelected}</strong> <br />
                {parcelSelected}
              </div>
            </React.Fragment>
          ) : paymentMethod.slug === 'safetypay' ? (
            selectedBank !== undefined && (
              <React.Fragment>
                <div>
                  <img src={`/assets/images/banks/${selectedBank.slug}.svg`} alt="" />
                </div>
                <div>
                  <span>Transferência</span> <br />
                  <strong>{selectedBank.name}</strong>
                </div>
              </React.Fragment>
            )
          ) : paymentMethod.slug === 'boleto' ? (
            <React.Fragment>
              <div>
                <img src="/assets/images/pagamento/boleto.svg" alt="boleto" />
              </div>
              <div>
                <strong>Boleto</strong>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div>
                <img src="/assets/images/pagamento/pix.svg" alt="pix" />
              </div>
              <div>
                <strong>Pix</strong>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect((state) => ({
    payment_methods: state.purchase.paymentMethods,
    parcels: state.purchase.creditCard.parcels,
    brands: state.purchase.creditCard.brands,
    banks: state.purchase.safetypay.banks,
  }))(BoxPaymentMethod)
);



// WEBPACK FOOTER //
// ./src/components/purchase/purchase_description/BoxPaymentMethod.jsx